/**
 * CardNoDataState.js
 *
 * Componente padronizado para estado sem dados disponíveis
 * dos cards do Executive Dashboard.
 */

import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import InboxOutlinedIcon from "@material-ui/icons/InboxOutlined";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    minHeight: (props) => props.minHeight || 180,
    padding: theme.spacing(2),
    backgroundColor: "rgba(0, 0, 0, 0.02)",
    borderRadius: theme.shape.borderRadius,
  },
  icon: {
    fontSize: 44,
    color: "#bdbdbd",
    marginBottom: theme.spacing(1.5),
  },
  title: {
    color: theme.palette.text.secondary,
    textAlign: "center",
    fontSize: "0.875rem",
    fontWeight: 500,
  },
  subtitle: {
    color: theme.palette.text.disabled,
    textAlign: "center",
    fontSize: "0.75rem",
    marginTop: theme.spacing(0.5),
  },
}));

/**
 * CardNoDataState - Estado sem dados padronizado
 *
 * @param {string} title - Título principal
 * @param {string} subtitle - Subtítulo (opcional)
 * @param {React.ElementType} icon - Ícone customizado (opcional)
 * @param {number} minHeight - Altura mínima do container
 */
export default function CardNoDataState({
  title = "Nenhum dado disponível",
  subtitle = null,
  icon: IconComponent = InboxOutlinedIcon,
  minHeight = 180,
}) {
  const classes = useStyles({ minHeight });

  return (
    <Box className={classes.container}>
      <IconComponent className={classes.icon} />
      <Typography className={classes.title}>{title}</Typography>
      {subtitle && (
        <Typography className={classes.subtitle}>{subtitle}</Typography>
      )}
    </Box>
  );
}

CardNoDataState.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  icon: PropTypes.elementType,
  minHeight: PropTypes.number,
};
